module.exports = __webpack_public_path__ + "img/section5_title2.59cb90da.png";